import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { DocumentsDataService } from './data-services/documents-data.service';
import { saveAs } from 'file-saver';
import { StorageServiceObservablesService } from './storage-service-observables/storage-service-observables.service';
import { ErrorRedirectionService } from './error-service/error-redirection.service';
import { UrlValidationService } from './document/url-validation.service';

@Injectable({
  providedIn: 'root'
})
export class IdCardService {

  constructor(
    private http: HttpClient,
    private documentsDataService: DocumentsDataService,
    private storageService: StorageServiceObservablesService,
    private errorRedirectionService: ErrorRedirectionService,
    private urlValidationService: UrlValidationService
    ) { }
    openUrlWhenDeviceIsIos(url) {
      if (this.urlValidationService.isApprovedRedirectUrl(url)){
      const windowRef = window.open();
      if (!this.documentsDataService.handlePopupBlocker(windowRef)) {
        windowRef.location = url;
      }
    }
    }
    
    viewIdCardForGivenResponse(blob) {
      const url: any = window.URL.createObjectURL(blob);
      if (this.documentsDataService.isItIosDevice()) {
        this.openUrlWhenDeviceIsIos(url);
      } else {
        const windowNonIos = window.open(url, '_blank');
        this.documentsDataService.handlePopupBlocker(windowNonIos);
      }
    }
    downloadIdCardForGivenResponse(blob) {
      //Commenting as it was intended for Internet Explorer which is no longer supported
      // if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      //   window.navigator.msSaveOrOpenBlob(
      //     blob,
      //     `Proof-of-Insurance.pdf`
      //   );
      // } else
       if (this.documentsDataService.isItIosDevice()) {
        const url: any = window.URL.createObjectURL(blob);
        this.openUrlWhenDeviceIsIos(url);
      } else {
        saveAs(blob, `Proof-of-Insurance.pdf`);
      }
    }
    
    listOfPolicyData(policy:any, selectedVehicles: any) {
      return {
        effDate: policy.effDate,
        expDate: policy.expDate,
        insured: policy.insured,
        mailingAddress: policy.mailingAddress,
        policyType: policy.policyType,
        policySubType: policy.policySubType,
        policyStatus: policy.policyStatus,
        policynumber: policy.policynumber,
        vehicle: selectedVehicles
      }
  }
  getIdCard(policy, action, policyNumber, selectedVehicles) {
    this.getProofDocument(this.storageService.getUserFromStorage(),
    [this.listOfPolicyData(policy, selectedVehicles)]).subscribe((blob) => {
      if (blob) {
        if (action === 'view') {
          this.viewIdCardForGivenResponse(blob);
        } else {
          this.downloadIdCardForGivenResponse(blob);
        }
      }
    }, (err) => {
      this.errorRedirectionService.errorRedirectHandler(err, policyNumber);
    })
  }
  getProofDocument(email, listOfPolicies): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    const url = `${environment.backend_server_url_account}/${email}/proof-of-insurance`;
    return this.http.post(url, listOfPolicies, { headers, responseType: 'blob' });
  }
}
